export const SET_ENTERPRISE = "SET_ENTERPRISE";
export const EDIT_USER = "EDIT_USER";
export const ADD_USER = "ADD_USER";
export const EDIT_ENTERPRISE = "EDIT_ENTERPRISE";
export const SAVE_LOGO = "SAVE_LOGO";
export const SAVE_BACKGROUND = "SAVE_BACKGROUND";
export const API_KEYS_IN_USE = "API_KEYS_IN_USE";
export const ADD_EXCEL = "ADD_EXCEL";
export const REMOVE_EXCEL = "REMOVE_EXCEL";
export const NOT_ADDED_HUBSPOTS = "NOT_ADDED_HUBSPOTS";